import { render, staticRenderFns } from "./RaceResults.vue?vue&type=template&id=0faac9ea&scoped=true"
import script from "./RaceResults.vue?vue&type=script&lang=js"
export * from "./RaceResults.vue?vue&type=script&lang=js"
import style0 from "./RaceResults.vue?vue&type=style&index=0&id=0faac9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faac9ea",
  null
  
)

export default component.exports